import React from "react"
import styled from "@emotion/styled"

import { queries } from "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"

import MensLogo from "-!svg-react-loader!../../assets/icons/nutrafol-logo-mens.svg"
import { clearSessionStorage } from "../../utils/general"

const mageProtocol = process.env.GATSBY_MAGENTO_API_PROTOCOL
const mageURL = process.env.GATSBY_MAGENTO_API_URL

const LogoArea = styled.div`
`
const LogoHolder = styled.div`
  width: 146px;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  svg {
    width: 100%;
  }
  ${queries.medium`
    svg {
      margin: 0 auto;
    }
  `}
`
const FakeLink = styled.div`
`

const clearStateSetLocation = () => {
  if (typeof window !== `undefined`) {
    clearSessionStorage()
    let linkDestination = mageProtocol + "://" + mageURL + "/men/"
    window.location = linkDestination
  }
}

const Logo = props => {

  return (
    <LogoArea className="logo-wrap">
      <FakeLink
        className="fake-link"
        onClick={() => clearStateSetLocation()}
      >
        <LogoHolder>
          <MensLogo />
        </LogoHolder>
      </FakeLink>
    </LogoArea>
  )
}

export default Logo
